import queryClient from 'app/services/queryClient';
import { LiveChatApiResponse, LiveChatItem } from 'app/hooks/fetch/useFetchLiveChat';
import { ChatItemType } from 'app/services/chatBot';
import { AxiosResponse } from 'axios';

export interface AnswerResponse {
  chat_items: LiveChatItem[];
  form: LiveChatItem;
}

const MESSAGE_DELAY = 1500;

function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function handleMutationSuccess(queryKey: (string | undefined)[]) {
  return async (res: AxiosResponse<AnswerResponse>) => {
    const form = res.data.form;
    const twilio_credentials = res.data?.chat_items?.find((item) => item.type === ChatItemType.TWILIO_CREDS);

    // replace updated form in chat_items
    queryClient.setQueryData(queryKey, (oldData: LiveChatApiResponse) => {
      return {
        ...oldData,
        chat_items: oldData.chat_items.map((item) => (item.ref_id === form.ref_id ? form : item)),
      };
    });

    // set twilio credentials
    if (twilio_credentials) {
      queryClient.setQueryData(queryKey, (oldData: LiveChatApiResponse) => {
        return {
          ...oldData,
          twilio_credentials,
        };
      });
    }

    // add new chat items with delay to show animation
    for await (const item of res.data.chat_items.reverse()) {
      if ([ChatItemType.FORM, ChatItemType.MESSAGE].includes(item.type)) {
        await sleep(MESSAGE_DELAY);
      }

      queryClient.setQueryData(queryKey, (oldData: LiveChatApiResponse) => {
        return {
          ...oldData,
          chat_items: [item, ...oldData.chat_items],
        };
      });
    }
  };
}
